import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const ratioAccommodationExtensionMapItemEntity: Entity = {
  model: model,
  repository: repository,
}

export default ratioAccommodationExtensionMapItemEntity
